import React from 'react';
import ReferralsPage from './ReferralsPage';

export default function EmployeeReferrals() {
  return <ReferralsPage title="Employee Referrals" userType="employee" />;
}
